"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBalanceFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4zm6.213 8.465c.229-.484.434-.919.434-1.641a2.824 2.824 0 00-5.647 0c0 1.127.369 3.576.84 5.647h3.837c-.247-2.35.174-3.24.536-4.006zm-.336 5.417h-3.68c.07.253.143.49.215.706.156.47.706 1.412 1.764 1.412 1.06 0 1.807-1.059 1.765-1.765l-.064-.353zM13.4 8.824c0 .722.206 1.157.434 1.641.363.767.783 1.656.537 4.006h3.836c.471-2.071.84-4.52.84-5.647a2.824 2.824 0 00-5.647 0zm4.45 7.058h-3.68c-.02.115-.041.233-.064.353-.042.706.706 1.765 1.765 1.765 1.058 0 1.608-.942 1.764-1.412.072-.216.144-.453.216-.706z' }))); };
exports.default = SvgBalanceFilled;
//# sourceMappingURL=BalanceFilled.js.map